import { Container } from 'pixi.js';
import { IGoalData } from '../../../Config/Levels';
import { createPixiText } from '../../../Utils/Utils';
import Core from '../../../Core/Core';
import { Collection } from '../../../Tiles/TileSet';
import { getSpriteId } from '../../../Utils/CollectableUtils';

/**
 * This is the group that displays the level goal on the PreLevelPopup.
 *
 * @params goals - an object that described the goal, definition of the object and its properties
 * can for found in Config/Levels (see import statement above). Its a typescript interface which basically just creates an type of
 * object with specific properties
 */
export class PrelevelGoalDisplay extends Container {
    constructor(goals: IGoalData[], width: number, height: number, collection: Collection) {
        super();
        const c = new Container();

        const bg = new PIXI.mesh.NineSlicePlane(
            PIXI.utils.TextureCache['mapui/booster-select-bg'],
            50,
            50,
            50,
            50
        );
        bg.width = width;
        bg.height = height;

        // access to the textures needed
        const goalIcon: PIXI.Sprite[] = [];

        const headerText = createPixiText(
            Core.local.getText('goals'),
            new PIXI.Rectangle(width / 2, height * 0.2, bg.width * 0.8, bg.height * 0.4),
            'Baloo',
            30,
            28,
            0xd53700
        );

        // in case of future levels having more than one goal, we use map to loop through each goal object
        // and create the text needed...

        const goalTxts = goals.map((goal, i) => {
            const charImage = 'top-hud-goal-icon-' + goal.type;
            const spriteId = getSpriteId('commonui/' + charImage, collection);
            goalIcon.push(new PIXI.Sprite(PIXI.utils.TextureCache[spriteId]));
            // g power \o/
            let g;
            // select the correct gap between the icon and the text
            if (goals.length === 1) {
                goalIcon[i].x = headerText.x;
                goalIcon[i].y = bg.y + bg.height / 2;
                goalIcon[i].anchor.set(0.5);
                let goalStr = goal.target.toString();
                if (goalStr === 'all') {
                    goalStr = Core.local.getText('all');
                }
                g = createPixiText(
                    goalStr,
                    new PIXI.Rectangle(width / 2, height * 0.2, bg.width * 0.8, bg.height * 0.4),
                    'Baloo',
                    30,
                    28,
                    0xd53700
                );
                g.x = headerText.x;
                g.y = goalIcon[i].y + goalIcon[i].height;
            } else {
                goalIcon[i].x = headerText.x - headerText.width * 1.5 + i * (bg.width / 2);
                goalIcon[i].y = headerText.y + headerText.height * 0.5;
                const goalStr = goal.target.toString();
                g = createPixiText(
                    goalStr,
                    new PIXI.Rectangle(width / 2, height * 0.2, bg.width * 0.8, bg.height * 0.4),
                    'Baloo',
                    30,
                    28,
                    0xd53700
                );
                g.x = goalIcon[i].x + goalIcon[i].width / 2;
                if (goal.type === 'pair' && goal.target === 'all') {
                    g.y = goalIcon[i].y + goalIcon[i].height * 1.45;
                } else {
                    g.y = goalIcon[i].y + goalIcon[i].height * 1.35;
                }
            }

            return g;
        });

        //@ts-ignore
        c.addChild(bg, headerText, ...goalIcon, ...goalTxts);

        this.addChild(c);
    }
}
